import { toast } from "react-toastify";
import { useMutation, useQuery } from "react-query";
import { handleEventForTracking } from "../amplitudeAnalytics";
import {
  addSpocDetails,
  bulkUploadSpocDetails,
  getSpocDetails,
  removeSpocDetails,
  updateSpocDetails,
} from "../api/spoc";
import { queryClient } from "./client";

export function useGetSpocDetails() {
  return useQuery({
    queryKey: "getSpocDetails",
    queryFn: getSpocDetails,
  });
}

export function useAddSpocDetails() {
  return useMutation({
    mutationKey: "addSpocDetails",
    mutationFn: addSpocDetails,
    onSuccess: () => {
      queryClient.invalidateQueries("getSpocDetails");
      queryClient.refetchQueries("getSpocDetails");
      handleEventForTracking({
        eventName: "addSpocDetails",
        success: true,
        eventType: "API",
      });
    },
    onError: () => {
      handleEventForTracking({
        eventName: "addSpocDetails",
        success: false,
        eventType: "API",
      });
    },
  });
}

export function useUpdateSpocDetails() {
  return useMutation({
    mutationKey: "updateSpocDetails",
    mutationFn: updateSpocDetails,
    onSuccess: () => {
      queryClient.invalidateQueries("getSpocDetails");
      queryClient.refetchQueries("getSpocDetails");
      handleEventForTracking({
        eventName: "updateSpocDetails",
        success: true,
        eventType: "API",
      });
    },
    onError: () => {
      handleEventForTracking({
        eventName: "updateSpocDetails",
        success: false,
        eventType: "API",
      });
    },
  });
}

export function useBulkUploadSpocDetails() {
  return useMutation({
    mutationKey: "bulkUploadSpocDetails",
    mutationFn: bulkUploadSpocDetails,
    onSuccess: () => {
      queryClient.invalidateQueries("getSpocDetails");
      queryClient.refetchQueries("getSpocDetails");
      handleEventForTracking({
        eventName: "bulkUploadSpocDetails",
        success: true,
        eventType: "API",
      });
    },
    onError: () => {
      handleEventForTracking({
        eventName: "bulkUploadSpocDetails",
        success: false,
        eventType: "API",
      });
    },
  });
}

export function useDeleteSpocDetails() {
  return useMutation({
    mutationKey: "removeSpocDetails",
    mutationFn: removeSpocDetails,
    onSuccess: () => {
      queryClient.invalidateQueries("getSpocDetails");
      queryClient.refetchQueries("getSpocDetails");
      toast("SPOC Removed Successfully!", {
        type: "success",
        autoClose: 2000,
      });
      handleEventForTracking({
        eventName: "removeSpocDetails",
        success: true,
        eventType: "API",
      });
    },
    onError: (error: any) => {
      toast(error, {
        type: "error",
        autoClose: 2000,
      });
      handleEventForTracking({
        eventName: "removeSpocDetails",
        success: false,
        eventType: "API",
      });
    },
  });
}
